import { Box, styled } from '@mui/material';

export const CardActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));
